import App from "@/App.vue";
import { createApp } from "vue";

const app = createApp(App);

export { app };
